module.exports = "https://static.energy5.com/_next/static/images/book-34398a6853b03ff7667cef91c745495e.png";